import { Component, inject } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AppMenuitem } from '@/layout/components/app.menuitem';
import { AuthStore } from '@/core/auth.store';
import { PANEL_PERMISSIONS } from '@/core/panel-permissions';

interface MenuItem {
    label?: string;
    icon?: string;
    routerLink?: string[];
    permission?: string;
    separator?: boolean;
    items?: MenuItem[];
}

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        @for (item of model; track item; let i = $index) {
            @if (!item.separator) {
                <li
                    app-menuitem
                    [item]="item"
                    [index]="i"
                    [root]="true"
                ></li>
            }
            @if (item.separator) {
                <li class="menu-separator"></li>
            }
        }
    </ul>`
})
export class AppMenu {
    private readonly authStore = inject(AuthStore);

    model: MenuItem[] = [];

    constructor() {
        const items: MenuItem[] = [
            {
                label: 'Inicio',
                icon: 'pi pi-fw pi-chart-bar',
                routerLink: ['/dashboard'],
                permission: PANEL_PERMISSIONS.DASHBOARD_VIEW
            },
            {
                label: 'Pedidos',
                icon: 'pi pi-fw pi-list',
                routerLink: ['/dashboard-pedidos'],
                permission: PANEL_PERMISSIONS.ORDERS_VIEW
            },
            {
                label: 'Notificações',
                icon: 'pi pi-fw pi-bell',
                routerLink: ['/dashboard-notifications'],
                permission: PANEL_PERMISSIONS.NOTIFICATIONS_VIEW
            },
            {
                label: 'Jobs',
                icon: 'pi pi-fw pi-briefcase',
                routerLink: ['/jobs'],
                permission: PANEL_PERMISSIONS.JOBS_VIEW
            },
            {
                label: 'Usuarios',
                icon: 'pi pi-fw pi-users',
                routerLink: ['/usuarios'],
                permission: PANEL_PERMISSIONS.USERS_VIEW
            },
            {
                label: 'Logs',
                icon: 'pi pi-fw pi-file',
                routerLink: ['/logs'],
                permission: PANEL_PERMISSIONS.LOGS_VIEW
            }
        ];

        const visibleItems = items.filter((item) => !item.permission || this.authStore.can(item.permission));

        this.model = visibleItems.length
            ? [
                  {
                      label: 'Dashboards',
                      icon: 'pi pi-home',
                      items: visibleItems
                  }
              ]
            : [];
    }
}
